import React from "react";
import "./ModalButton.scss";

const ModalButton = (props) => {
  const { buttonText, onClick, isSecondary, btnCss } = props;
  return (
    <button className={`modal-button ${isSecondary ? '--secondary' : '--primary'} ${btnCss ?? ''}`} onClick={onClick} >
      {buttonText}
    </button >
  );
};

export default ModalButton;